module.exports = __webpack_public_path__ + "img/federacion-logo-footer.2512fe16.svg";